import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Star, Users } from "lucide-react"

export const CTASection = () => {
  return (
    <section className="px-4 pb-16">
      <div className="container mx-auto max-w-6xl">
        <div className="rounded-3xl border border-primary/20 bg-gradient-to-r from-primary/15 via-primary/5 to-cyan-500/10 px-6 py-10 text-center shadow-[0_14px_50px_rgba(2,6,23,0.08)] md:px-10">
          <h2 className="text-3xl font-bold text-foreground">¿Listo para competir?</h2>
          <p className="mx-auto mt-3 max-w-2xl text-lg text-muted-foreground">
            Crea tu cuenta y empieza a registrar tus resultados para subir en los rankings.
          </p>
          <div className="mt-6 flex flex-col justify-center gap-4 sm:flex-row">
            <Link to="/register">
              <Button size="lg" className="bg-gradient-primary shadow-glow animate-glow-pulse">
                <Star className="mr-2 h-5 w-5" />
                Registrarse Ahora
              </Button>
            </Link>
            <Link to="/login">
              <Button size="lg" variant="outline">
                <Users className="mr-2 h-5 w-5" />
                Iniciar Sesión
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
